/** Hours since midnight (0–24); string "HH:mm" from API does not sort with Number(). */
function parseActionTimeToSortableHours(actionTime) {
  if (actionTime == null || actionTime === "") {
    return Number.POSITIVE_INFINITY;
  }
  if (typeof actionTime === "number" && Number.isFinite(actionTime)) {
    const date = new Date(actionTime * 1000);
    return (
      date.getHours() + date.getMinutes() / 60 + date.getSeconds() / 3600
    );
  }
  if (typeof actionTime === "string") {
    const trimmed = actionTime.trim();
    if (!trimmed) {
      return Number.POSITIVE_INFINITY;
    }
    if (/^\d+(\.\d+)?$/.test(trimmed)) {
      const numeric = Number(trimmed);
      if (Number.isFinite(numeric)) {
        const date = new Date(numeric * 1000);
        return (
          date.getHours() + date.getMinutes() / 60 + date.getSeconds() / 3600
        );
      }
    }
    if (trimmed.includes(":")) {
      const parts = trimmed.split(":").map((part) => Number(part));
      if (parts.length >= 2 && parts.every((value) => Number.isFinite(value))) {
        const [hours, minutes, seconds = 0] = parts;
        return hours + minutes / 60 + seconds / 3600;
      }
    }
  }
  return Number.POSITIVE_INFINITY;
}

export function sortRoutinesByActionTimeAsc(items = []) {
  return [...items].sort((a, b) => {
    const ta = parseActionTimeToSortableHours(a?.actionTime);
    const tb = parseActionTimeToSortableHours(b?.actionTime);
    if (ta !== tb) {
      return ta - tb;
    }
    return (a?.routineId ?? 0) - (b?.routineId ?? 0);
  });
}
